import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class LoginService {
  url = "https://niivsnes.humge.com";
  constructor(private http:HttpClient) {
   }
  
  login(data):Observable<any>{
    return this.http.post(this.url+'/api/login',data);
  }

  checkAuth():Observable<any>{
    return this.http.get(this.url+'/api/checkAuth?token='+localStorage.getItem('token'));
  }

  getUser(data):Observable<any>{
    return this.http.post(this.url+'/api/user',data);
  }
}
